import CustomElement from '../core/custom.js';

export default window.customElements.define('manager-item', class extends CustomElement {
    constructor() {
        super();

		this.events = {
			'click .js-manager-img': 'onClick'
		}
    }

    connectedCallback() {
        super.connectedCallback()

		this.$collapse = this.querySelector('collapse-object')
    }

    disconnectedCallback() {
        super.disconnectedCallback();
    }

	onClick() {
		this.$collapse.onCollapse()
	}
});